import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "50.331",
  height: "50.109",
  viewBox: "0 0 14.331 16.109"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#37dba8",
  d: "M6.611 12.77c0 .194.028.361.028.555H.551A.555.555 0 0 1 0 12.77V11.1a4.436 4.436 0 0 1 3.939-4.414 3.581 3.581 0 1 1 3.691 0 4.382 4.382 0 0 1 2.975 1.666 4.423 4.423 0 0 0-3.994 4.418zm6.749 2.36a3.29 3.29 0 0 1-4.683 0 3.353 3.353 0 0 1 0-4.719 3.29 3.29 0 0 1 4.683 0 3.353 3.353 0 0 1 0 4.719zm-2.066-2.637a.276.276 0 1 0-.551 0v2.221a.276.276 0 1 0 .551 0zm.275-1.388a.551.551 0 1 0-.551.555.555.555 0 0 0 .551-.56z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };